import * as Yup from "yup";

export const roleExteraDiscountValidation = Yup.object().shape({
  percent: Yup.string().required("وارد کردن درصد تخفیف الزامی است"),
});

export const linkCodeExteraDiscountValidation = Yup.object().shape({
  percent: Yup.string().required("وارد کردن درصد تخفیف الزامی است"),
  linkCode: Yup.string().required("وارد کردن لینک ارجاع الزامی است"),
});
